// utils/RandomQuestions.ts

import { STRINGS } from "./strings";


export function getRandomAnswer(current: string) { 
  const filtered = STRINGS.answers.filter(q => q !== current);
  return filtered[Math.floor(Math.random() * filtered.length)];
}
